module.exports = __webpack_public_path__ + "img/2Y.01168bc5.jpg";